/**
 * VISALL 验证配置加载器 - 简化版
 * 直接导入和使用配置映射，无需复杂的动态加载
 */

import type { ValidationConfig } from './types';
import { getValidationConfig } from '../../layer/validationConfigs';

/**
 * 简化的验证配置加载器
 * 直接使用静态导入的配置映射，性能优异
 */
export class ValidationConfigLoader {
  /**
   * 获取指定图层类型的验证配置
   * @param layerType 图层类型（如：'bar', 'line', 'pie'）
   * @returns 验证配置对象
   */
  static getConfig(layerType: string): ValidationConfig {
    return getValidationConfig(layerType);
  }

  /**
   * 检查指定图层类型是否有可用的验证配置
   * @param layerType 图层类型
   * @returns 是否有配置
   */
  static hasConfig(layerType: string): boolean {
    try {
      const config = getValidationConfig(layerType);
      return config !== undefined && config.fields.length > 0;
    } catch (error) {
      console.warn(`Failed to load validation config for layer type: ${layerType}`, error);
      return false;
    }
  }

  /**
   * 获取所有支持的图层类型列表
   * @returns 图层类型数组
   */
  static getSupportedLayerTypes(): string[] {
    // 从配置映射中获取所有支持的图层类型
    return [
      'bar',
      'line',
      'pie',
      'scatter',
      'funnel',
      'gauge',
      'radar',
      'tree',
      'treeMap',
      'hxKLine',
      'text',
      'other'
    ];
  }
}
